"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { List } from "@nxt-costco-com/forge-components";
import { SpaceSm, SpaceMd, FontLineHeightMd, FontSize300, ColorWhite, SpaceLg, BpXl, FontSize200, ColorGray800, ColorBlue500 } from "@nxt-costco-com/forge-design-tokens";
import { ONETRUST_BUTTON_ID } from "../SystemDefinedLink/CookieSettings/constants.js";
const listStyles = {
  li: {
    alignItems: "center",
    display: "flex"
  }
};
const LinkListRow = styled(Box, {
  shouldForwardProp: (prop) => ![
    "backgroundGradientStyle",
    "backgroundColor",
    "firstBackgroundColor",
    "secondBackgroundColor",
    "textColor"
  ].includes(prop)
})(({
  theme,
  backgroundGradientStyle,
  backgroundColor,
  firstBackgroundColor,
  secondBackgroundColor,
  textColor
}) => {
  const background = backgroundGradientStyle === "solid" ? backgroundColor : backgroundGradientStyle === "linear" ? `linear-gradient(${firstBackgroundColor}, ${secondBackgroundColor})` : backgroundGradientStyle === "radial" ? `radial-gradient(${firstBackgroundColor}, ${secondBackgroundColor})` : "transparent";
  const buttonStyles = {
    color: textColor || ColorWhite,
    fontSize: FontSize300,
    lineHeight: FontLineHeightMd,
    marginLeft: 0
  };
  const typographyStyles = {
    color: textColor || ColorWhite,
    fontSize: FontSize300,
    lineHeight: FontLineHeightMd,
    marginLeft: "0px",
    paddingBottom: "10px",
    paddingLeft: "3px",
    paddingTop: "10px"
  };
  const buttonBaseStyles = {
    paddingBottom: "10px",
    paddingTop: "10px"
  };
  return {
    "&.hasBackground": {
      background,
      alignItems: "flex-start",
      alignSelf: "center",
      display: "inline-flex",
      gap: "18px",
      margin: "0",
      maxWidth: BpXl,
      padding: `0 ${SpaceLg} 0 ${SpaceLg}`,
      position: "relative",
      width: "100%",
      "> nav:first-of-type": {
        margin: "0",
        "a.MuiButton-root:first-of-type": {
          ...buttonStyles,
          ...typographyStyles
        },
        button: {
          ...buttonStyles
        },
        "nav > ul": {
          marginBottom: "0px",
          "li:last-child": {
            paddingBottom: "0px"
          }
        },
        "> li": {
          ".MuiButton-root": buttonStyles
        }
      },
      "> nav > ul, > div > ul": {
        gap: "18px",
        margin: "0",
        "> li": {
          ".MuiButton-root": buttonStyles,
          "> a .MuiTypography-root": typographyStyles,
          "> div > a": {
            "&.MuiButtonBase-root": buttonBaseStyles
          },
          alignContent: "center",
          marginLeft: "0",
          marginTop: "0",
          ":last-child": {
            paddingBottom: "0px"
          }
        }
      },
      ".MuiPopper-root": {
        textAlign: "left"
      },
      [theme.breakpoints.down("sm")]: {
        padding: `${SpaceSm} ${SpaceMd} ${SpaceSm} ${SpaceMd}`
      }
    }
  };
});
const footerListStyles = {
  li: {
    // style Text children
    ".MuiTypography-root": {
      color: ColorGray800
    },
    alignItems: "center",
    // style button children
    button: {
      color: ColorGray800,
      lineHeight: 1.7
    },
    display: "flex",
    // override pesky OneTrust styles on CookieSettings button
    [`#${ONETRUST_BUTTON_ID}`]: {
      color: ColorGray800,
      fontSize: `${FontSize200}!important`,
      lineHeight: "1.7!important"
    }
  }
};
const headerListStyles = {
  li: {
    // style Text children
    ".MuiTypography-root": {
      color: ColorBlue500
    },
    alignItems: "center",
    // style button children
    button: {
      color: ColorBlue500,
      lineHeight: 1.7
    },
    display: "flex",
    // override pesky OneTrust styles on CookieSettings button
    [`#${ONETRUST_BUTTON_ID}`]: {
      color: ColorBlue500,
      fontSize: `${FontSize200}!important`,
      lineHeight: "1.7!important"
    }
  }
};
const ListWithGridDisplay = styled(List, {
  shouldForwardProp: (prop) => prop !== "maxLinksPerColumn"
})(({ maxLinksPerColumn }) => ({
  columnGap: SpaceLg,
  display: "grid",
  gridAutoFlow: "column",
  gridTemplateRows: `repeat(${maxLinksPerColumn}, auto)`,
  listStyle: "none"
}));
export {
  LinkListRow,
  ListWithGridDisplay,
  footerListStyles,
  headerListStyles,
  listStyles
};
